import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import ReactMultiSelectWrapper from '../../common/ReactMultiSelectWrapper';
import '../../css/forms/default-forms.css';
import { basic as basicFields } from './fields';
import {
  getList, getContactsByProjectId
} from '../../api/projects';
import {
  fetchDetailsWithoutProperty,
  fetchAllTasks,
} from '../../api/dashboard';
import {
  getPdfOfTaskByFields,
  getListOfFields,
  addNewTask,
  getWORecent,
  getPaintListAll,
  getSalesPersonsListAll,
} from '../../api/task';
import { getVendorsList } from '../../api/vendors';
import {
  findByField,
} from '../../utils/arrObj';
import { validateFields } from '../../utils/validate';
import {
  prepareDynamicList,
  createListOfFields,
  customProcessFields,
} from './data';
import FinInfo from '../../common/FinInfo';
import SuppliesLog from '../../common/SuppliesLog';
import Materials from '../../common/Materials';
import moment from "moment";
import PopUp from '../../common/PopUp';
import CKEditorComponent from "../../сomponents/CKEditor";

export class WorkOrderAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: clone(basicFields),
      hasPdf: false,
      hasDynamicList: false,
      dynamicListOfFields: [],
      supplieData: [],
      supplieDataV2: [],
      materialsData: [{
        id: Math.random(),
        material_id: '',
        name: '',
        quantity: '',
        price: '',
        subtotal: '',
      }],
      finInfo: {'material': '', 'labor': '', 'price': '', 'price-paint': '', 'price-body': '', 'taxes': '', 'body-work': ''}
    };


    this.ckeEditorScopeOfWordRef = element => {
      this.scopeOfWordRef = element;
    };

    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.showPdfButtom = this.showPdfButtom.bind(this);
    this.getPdfButton = this.getPdfButton.bind(this);
    this.donwloadPdfPreview = this.donwloadPdfPreview.bind(this);
    this.getCustomerCode = this.getCustomerCode.bind(this);
    this.generateWOField = this.generateWOField.bind(this);
    this.renderDynamicList = this.renderDynamicList.bind(this);
    this.loadJobCards = this.loadJobCards.bind(this);
    this.changeMaterials = this.changeMaterials.bind(this);
    this.changeSuppliesLog = this.changeSuppliesLog.bind(this);
    this.changeSuppliesLogV2 = this.changeSuppliesLogV2.bind(this);
    this.removeSuppliesLogV2 = this.removeSuppliesLogV2.bind(this);
    this.changeFinancialInfo = this.changeFinancialInfo.bind(this);
    this.parseContactList = this.parseContactList.bind(this);
    this.getMaterialsCost = this.getMaterialsCost.bind(this);
    this.handleAddContacts = this.handleAddContacts.bind(this);
  }

  componentWillMount() {
    this.props.getPaintList();
    this.props.getCustomerList();
    this.props.getStages();
    this.props.getTasks();
    this.props.getWoFields();
    this.props.getSalesPersonsList();
    this.props.getVendors();
  }

  componentWillReceiveProps(nextProps) {
    let dynamicList = path(['tasks', 'dynamicList'], this.props);

    if (dynamicList && !this.state.hasDynamicList) {
      const list = prepareDynamicList(dynamicList);
      let fields = createListOfFields(list);
      if (fields) {
        this.setState({
          dynamicListOfFields: fields,
          hasDynamicList: true,
        });
      }
    }
  }

  submit(e) {
    e.preventDefault();

    for (let key in this.state.dynamicListOfFields) {
      const field = this.state.dynamicListOfFields[key];
      if (field.label === 'Status') {
        if (typeof field.value !== 'string') {
          this.state.dynamicListOfFields[key].value = 'new';
        }
      } else if (field.label === 'Priority') {
        if (typeof field.value !== 'string') {
          field.value = 'High';
        }
      } else if (field.label === 'Financial Info') {
        field.value = JSON.stringify(this.state.finInfo);
      } else if (field.label === 'Paint List') {
        field.value = [];
      } else if (Object.prototype.toString.call(field.value) === '[object Date]') {
        field.value = moment(field.value).format('M/D/YYYY h:mm a');
      } else if (field.label === 'Quality Control') {
        if (field.value == '') {
          this.state.dynamicListOfFields[key].value = 'Yes';
        }
      } else if (field.label === 'Scope of Work') {
        this.state.dynamicListOfFields[key].value = this.scopeOfWordRef.editor.getData();
      }
    }



    let result = validateFields(this.state.fields);
    let dynamicResult = validateFields(this.state.dynamicListOfFields);
    if (result.check === true && dynamicResult.check === true) {
      this.props.saveForm(
        customProcessFields(
          this.state.fields,
          this.state.dynamicListOfFields,
          this.state.supplieData,
          this.state.materialsData,
          this.state.supplieDataV2,
        )
      );
    } else {
      this.setState({
        fields: result.fields,
        dynamicListOfFields: dynamicResult.fields,
      });
    }

    // return false;
  }

  getMaterialsCost() {
    const materialsCost = this.state.materialsData
      .filter((item) => Boolean(item.name))
      .reduce((acc, item) => acc + Number(item.subtotal), 0);
    const suppliesCost = this.state.supplieDataV2
      .filter((item) => Boolean(item.vendor))
      .reduce((acc, item) => item.materials
        .filter((matItem) => Boolean(matItem.name))
        .reduce((acc2, matItem) => acc2 + Number(matItem.subtotal), acc), 0);

    return materialsCost + suppliesCost;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field == 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;

      if (field == 'customer') {
        this.generateWOField().then((data) => {
          stateClone.fields['workOrder'].value = data;
          this.setState(mergeDeepLeft(stateClone, this.state));
        });

        if (newObject.value) {
          this.props.getContactList(newObject.value);
        } {
          this.props.getContactList(undefined);
        }

      } else {
        this.setState(mergeDeepLeft(stateClone, this.state));
      }
    }
  }

  cancel() {
    this.props.goToDashboard();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.hasPdf === false) {
      this.showPdfButtom();
    }
  }

  generateWOField() {
    let stateClone = clone(this.state);

    return this.props.getWoIdForCustomer(
      parseInt(stateClone.fields['customer'].value)
    );
  }

  getCustomerCode(id, lastElementId) {
    const customerList = this.parseCustomersList(path(['projects', 'list'], this.props)) || [];

    if (customerList && customerList.length > 0 && id && lastElementId) {
      const currentCustomer = findByField(id, customerList, 'value');

      if (currentCustomer && currentCustomer.label) {
        let code = currentCustomer.label.split('-');
        let result = '';

        if (code.length > 1) {
          result = code[0].replace(/\s/g, '') + ' ' + (lastElementId + 1);
        } else {
          result = code[0] + ' ' + (lastElementId + 1);
        }

        return result;
      }
    }

    return '';
  }

  parseCustomersList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          label: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  parseContactList(arr) {
    const arrContacts = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        let type = arr[i].type.join('/');
        type = type ? ` (${type})`:type;
        const phone = arr[i].phone ? `, tel.: ${arr[i].phone}`: '';
        const email = arr[i].email ? `, email.: ${arr[i].email}`: '';

        arrContacts.push({
          value: arr[i].id,
          label: `${arr[i].firstname} ${arr[i].lastname}${phone}${email}${type}`,
          name: `${arr[i].firstname} ${arr[i].lastname}`
        });
      }
    }

    return arrContacts;
  }

  showPdfButtom() {
    const customer = this.state.fields.customer;
    if (this.state.hasPdf === false && customer && customer.value) {
      this.setState({
        hasPdf: true,
      });
    }
  }

  donwloadPdfPreview(e) {
    e.preventDefault();
    this.props.downloadPdf(
      customProcessFields(this.state.fields, this.state.dynamicListOfFields),
      this.state.fields['workOrder'].value
    );
    return false;
  }

  getPdfButton() {
    if (this.state.hasPdf) {
      return (
        <button
          type="button"
          className={'btn btn-info btn-outline float-right'}
          onClick={this.donwloadPdfPreview}
          style={{
            marginLeft: '10px',
          }}
        >
          <i className="fa fa-file-pdf-o"></i>
          <span style={{paddingLeft: '3px'}}>PDF Preview</span>
        </button>
      );
    }
    return null;
  }

  loadJobCards() {
    const jcList = path(['jobCards', 'list'], this.props) || [];
    const newJCList = {};
    if (jcList && jcList.length > 0) {
      for (let i = 0; i < jcList.length; i++) {
        newJCList[jcList[i].id] = {
          label: jcList[i].label
        }
      }
    }

    return newJCList;
  }

  getStatusStaticOptions() {
    return [
      {
        value: 'new',
        text: 'New',
      },
      {
        value: 'hold',
        text: 'Hold',
      },
      {
        value: 'in_progress',
        text: 'In Progress',
      },
      {
        value: 'hot',
        text: 'HOT',
      },
      {
        value: 're_work',
        text: 'Re-work',
      },
      {
        value: 'ready',
        text: 'Ready',
      },
      {
        value: 'closed',
        text: 'Closed',
      },
    ];
  }

  getPermission(permAreaKey, permTypeKey) {
    if (!permTypeKey) {
      permTypeKey = 'view';
    }

    const perm = this.props.users.userProfile.permission.find(item => item.permAreaKey === permAreaKey && item.permTypeKey === permTypeKey);
    return perm && perm.value === 'on';
  }

  renderDynamicList() {
    const arrOfFields = [];
    const paintListAll = path(['tasks', 'paintListAll'], this.props) || [];
    const vendorsList = path(['vendors', 'list'], this.props) || [];

    if (this.state.dynamicListOfFields && this.state.dynamicListOfFields.length > 0) {
      const viewFinPerm = this.getPermission("work_order_financial", "view");
      const editFinPerm = this.getPermission("work_order_financial", "edit");
      const viewMatPricesPerm = this.getPermission("material_prices", "view");
      const editMatPricesPerm = this.getPermission("material_prices", "edit");

      for (let i = 0; i < this.state.dynamicListOfFields.length; i++) {
        const currentValue = this.state.dynamicListOfFields[i];
        if (currentValue && currentValue.system && currentValue.system.component) {
          const Component = currentValue.system.component;
          let wrapperClass = 'col-12';
          if (currentValue.style && currentValue.style.grid) {
            wrapperClass = currentValue.style.grid;
          }

          // Fix: this should be in the data base
          if (currentValue.label === 'Status') {
            currentValue.source = this.getStatusStaticOptions();
          }

          if (currentValue.label === 'Materials') {
            arrOfFields.push(
              <div className={wrapperClass} key={i}>
                <Materials
                  materials={this.state.materialsData}
                  vendors={vendorsList}
                  onChange={this.changeMaterials}
                  financialFieldsVisible={viewMatPricesPerm}
                  financialFieldsDisabled={!editMatPricesPerm}
                />
              </div>
            );
            continue;
          }

          if (currentValue.label === 'Paint List') {
            arrOfFields.push(
              <div className={wrapperClass} key={i}>
                <SuppliesLog
                  paintListAll={paintListAll}
                  fields={this.state.supplieData}
                  fieldsV2={this.state.supplieDataV2}
                  onChange={this.changeSuppliesLog}
                  onChangeV2={this.changeSuppliesLogV2}
                  onRemoveV2={this.removeSuppliesLogV2}
                  vendorsList={vendorsList}
                  financialFieldsVisible={viewMatPricesPerm}
                  financialFieldsDisabled={!editMatPricesPerm}
                />
              </div>
            );
            continue;
          }

          // Skip Financial Info field
          if (currentValue.label === 'Financial Info' && viewFinPerm) {
            arrOfFields.push(
              <div className={wrapperClass} key={i}>
                <FinInfo
                  disabled={!editFinPerm}
                  fields={this.state.finInfo}
                  getMaterialsCost={this.getMaterialsCost}
                  onChange={this.changeFinancialInfo}
                />
              </div>
            );
            continue;
          }

          if (currentValue.label == 'Scope of Work') {
            arrOfFields.push(
              <div key={i} className={wrapperClass} style={{marginTop: '20px', marginBottom: '20px'}}>
                <CKEditorComponent
                  field={currentValue}
                  refLink={this.ckeEditorScopeOfWordRef}
                />
              </div>
            );
            continue;
          }

          arrOfFields.push(
            <div className={wrapperClass} key={i}>
              <Component
                field={currentValue}
                onChange={this.changeFormValue}
              />
            </div>
          );
        }
      }
    }
    return (<div className="row">{arrOfFields}</div>);
  }

  changeMaterials(index, field, value) {
    if (field === 'delete') {
      let stateClone = clone(this.state);

      stateClone.materialsData.splice(index, 1);

      this.setState(mergeDeepLeft(stateClone, this.state));
    } else {
      let stateClone = clone(this.state);

      if (field === 'material') {
        if (value) {
          const addNew = !stateClone.materialsData[index].name;

          if (value.label === value.value) {
            stateClone.materialsData[index].price = '0';
          } else {
            stateClone.materialsData[index].material_id = value.value;
            stateClone.materialsData[index].price = value.cost;
          }
          stateClone.materialsData[index].name = value.label;
          stateClone.materialsData[index].quantity = '1';
          stateClone.materialsData[index].unit_of_measure = value.unit_of_measure;

          if (addNew) {
            stateClone.materialsData.push({
              id: Math.random(),
              material_id: '',
              name: '',
              quantity: '',
              price: '',
              subtotal: '',
            });
          }
        }
      } else {
        stateClone.materialsData[index][field] = value;
      }

      stateClone.materialsData[index].subtotal =
      Number(stateClone.materialsData[index].price.replace(',', '')) *  Number(stateClone.materialsData[index].quantity);

      this.setState(mergeDeepLeft(stateClone, this.state));
    }
  }

  removeSuppliesLogV2(id) {
    this.props.handleObjectToDelete({
      id: id,
      handler: data => {
        if (id) {
          const index = this.state.supplieDataV2.findIndex((x) => x.id === data.id);

          if (index > -1) {
            this.setState({supplieDataV2: this.state.supplieDataV2.splice(index, 1)});
          }
        } else {
          const supplieDataV2 = this.state.supplieDataV2;
          const state = {
            supplieDataV2: supplieDataV2.splice(0, supplieDataV2.length),
            data: this.state.data ? clone(this.state.data) : {}
          };
          const paintList = state.data.find(v => v.label == 'Paint List');
          if (paintList) {
            paintList.content = [];
          }

          this.setState(state);
        }
      }
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: id ? 'deleteSlById' : 'deleteSlAll',
    });
  }

  changeSuppliesLogV2(value, field, parentField) {
    const stateClone = clone(this.state);
    switch (field) {
      case 'add': {
        stateClone.supplieDataV2.push({
          id: `${Date.now()}-${Math.round(Math.random() * 10000)}`,
          frontend_suplog_id: `${Date.now()}-${Math.round(Math.random() * 10000)}`,
          vendor: null,
          comments: null,
          materials: [{
            id: Math.random(),
            material_id: '',
            name: '',
            quantity: '',
            price: '',
            subtotal: '',
          }],
        });
        break
      }
      case 'delete': {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === value);

        if (index > -1) {
          stateClone.supplieDataV2.splice(index, 1);
        }
        break;
      }
      case 'delete_all': {
        stateClone.supplieDataV2 = [];
      }
      case 'materials': {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === parentField);

        if (index > -1) {
          const materials = stateClone.supplieDataV2[index].materials;

          if (value.name === 'delete') {
            materials.splice(value.index, 1);

            if (!materials.length) {
              materials.push({
                id: Math.random(),
                material_id: '',
                name: '',
                quantity: '',
                price: '',
                subtotal: '',
              });
            }
          } else {
            if (value.name === 'material') {
              const data = value.value;

              materials[value.index].material_id = data.value;
              materials[value.index].name = data.label;
              materials[value.index].price = data.cost;
            } else if (value.name === 'delete') {
              materials.splice(index, 1);
            } else {
              materials[value.index][value.name] = value.value.split(',').join('');
            }
            materials[value.index].subtotal = (materials[value.index].price || 0) * (materials[value.index].quantity || 0);
            materials[value.index] = { ...materials[value.index] };

            if (materials[materials.length - 1].name) {
              materials.push({
                id: Math.random(),
                material_id: '',
                name: '',
                quantity: '',
                price: '',
                subtotal: '',
              });
            }
          }

          stateClone.supplieDataV2[index] = { ...stateClone.supplieDataV2[index], 'materials': [...materials] };
        }
        break;
      }
      default: {
        const index = stateClone.supplieDataV2.findIndex((data) => data.id === parentField);

        if (index > -1) {
          stateClone.supplieDataV2[index] = { ...stateClone.supplieDataV2[index], [field]: value };
        }
        break;
      }
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  changeSuppliesLog(name, field, parentField) {
    if (field == 'delete') {
      let stateClone = clone(this.state);

      stateClone.supplieData.splice(parseInt(name), 1);

      this.setState(mergeDeepLeft(stateClone, this.state));
    } else if (field == 'add') {
      let stateClone = clone(this.state);

      stateClone.supplieData.push({
        emails: '',
        data: {
          id: 0,
          paint: null,
          checked: false,
        },
      });

      this.setState(mergeDeepLeft(stateClone, this.state));
    } else if (field == 'delete_all') {
      let stateClone = clone(this.state);

      stateClone.supplieData = [];

      this.setState(mergeDeepLeft(stateClone, this.state));
    } else {
      let stateClone = clone(this.state);
      // Convert name
      if (name == 'input') {
        name = 'id';
      } else if (name == 'checkbox') {
        name = 'checked';
      } else {
        name = 'paint';
      }

      if (stateClone.supplieData[parentField]) {
        if (field.label == 'Mail to Vendor' && stateClone.supplieData[parentField]) {
          stateClone.supplieData[parentField].data.checked = field.value;
        } else if (field.label == 'Supplies') {
          stateClone.supplieData[parentField].data.paint = field.value;
        } else if (field.label == 'Emails') {
          stateClone.supplieData[parentField].emails = field.value;
        } else if (field.label == 'Mail will be sent if you save this change to Work Order') {
          stateClone.supplieData[parentField].data.checked = field.value;
        } else {
          stateClone.supplieData[parentField].data = field.value;
        }
      }

      this.setState(mergeDeepLeft(stateClone, this.state));
    }
  }

  changeFinancialInfo(name, field) {
    let stateClone = clone(this.state);

    stateClone.finInfo[name] = field.value;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  linkProjects() {
    const lanes = path(['dashboard', 'lanes'], this.props) || [];
    if (lanes) {
      const boardLanes = [];

      for (let i = 0; i < lanes.length; i++) {
        let currentLane = lanes[i];

        boardLanes.push({
          value: currentLane.id,
          label: currentLane.label,
        });
      }
      return boardLanes;
    }
  }

  parseSalesPersonsList(salesPersonsList) {
    return (salesPersonsList || []).map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    }));
  }

  handleAddContacts() {
    const selectedCustomer = this.state.fields['customer'].value;
    const { goToCustomer } = this.props;
    goToCustomer(selectedCustomer);
  }

  render() {
    const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
    const contactsList = this.parseContactList(path(['projects', 'contacts'], this.props));
    const salesPersonsList = this.parseSalesPersonsList(path(['tasks', 'salesPersonsList'], this.props));
    const selectedCustomer = this.state.fields['customer'].value;

    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
            {url: '/pages/customers', icon: 'link', name: 'Quick Links'},
            {icon: 'add_to_photos', name: 'Add Work Order'},
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Work Order
            </div>
            <div className="card-block">
              <div className="col-12" style={{paddingBottom: '40px'}}>
                <button
                  type="button"
                  className={'btn btn-danger btn-outline float-right'}
                  style={{marginLeft: '10px'}}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{paddingLeft: '3px'}}>Cancel</span>
                </button>
                {this.getPdfButton()}
                <button
                  type="button"
                  className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{paddingLeft: '3px'}}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <ReactSelectWrapper
                    options={customerList}
                    field={this.state.fields['customer']}
                    onChange={this.changeFormValue}
                  />
                  {contactsList && contactsList.length && (<ReactMultiSelectWrapper
                    options={contactsList}
                    autoFocus={false}
                    field={this.state.fields['contacts']}
                    onChange={this.changeFormValue}
                    transformSelected={o => ({...o, title: o.label, label: o.name})}
                  />) || null}
                  {selectedCustomer && (<PopUp
                    id={'CustomerContactmissing'}
                    show={contactsList && contactsList.length === 0}
                    title={'Customer Contact missing'}
                    onAddContacts={this.handleAddContacts}
                    content={'There are no contacts assigned to the selected Customer. Please add at least one Contact to Proceed'}
                    yesCaption={'Manage Customer Contacts'}
                  />)}
                  <ReactSelectWrapper
                    options={this.linkProjects()}
                    className={'col-12'}
                    autoFocus={false}
                    field={this.state.fields['project']}
                    onChange={this.changeFormValue}
                  />
                  <ReactSelectWrapper
                    options={salesPersonsList}
                    className={'col-12'}
                    autoFocus={false}
                    field={this.state.fields['salesRep']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['workOrder']}
                    onChange={this.changeFormValue}
                  />

                  {this.renderDynamicList()}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerList: () => {
      getList()(dispatch);
    },
    getContactList: (id) => {
      getContactsByProjectId(id)(dispatch);
    },
    getWoIdForCustomer: (id) => {
      return getWORecent(id)(dispatch);
    },
    getPaintList: () => {
      getPaintListAll()(dispatch)
    },
    downloadPdf: (data, woName) => {
      getPdfOfTaskByFields(data, woName)(dispatch);
    },
    getStages: () => {
      fetchDetailsWithoutProperty()(dispatch);
    },
    getTasks: () => {
      fetchAllTasks()(dispatch);
    },
    getWoFields: () => {
      getListOfFields()(dispatch);
    },
    goToCustomer: (id) => {
      dispatch(push('/pages/edit-customer/' + id))
    },
    goToDashboard: () => {
      dispatch(push('/pages/dashboards'));
    },
    saveForm: (data) => {
      addNewTask(data)(dispatch);
    },
    getSalesPersonsList: () => {
      getSalesPersonsListAll()(dispatch)
    },
    getVendors: () => {
      getVendorsList()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderAdd);



// WEBPACK FOOTER //
// ./src/containers/WorkOrderAdd/index.js